/**
 * Register React globals for external plugin UI bundles.
 *
 * External plugins are built with React aliased to
 * `globalThis.__MAGIC_MD_REACT__` so they share the host app's
 * React instance. This must be called BEFORE loading any external plugins.
 */
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as jsxRuntime from "react/jsx-runtime";

declare global {
    // eslint-disable-next-line no-var
    var __MAGIC_MD_REACT__: typeof React;
    // eslint-disable-next-line no-var
    var __MAGIC_MD_REACT_DOM__: typeof ReactDOM;
    // eslint-disable-next-line no-var
    var __MAGIC_MD_JSX_RUNTIME__: typeof jsxRuntime;
}

export function registerReactGlobals(): void {
    globalThis.__MAGIC_MD_REACT__ = React;
    globalThis.__MAGIC_MD_REACT_DOM__ = ReactDOM;
    globalThis.__MAGIC_MD_JSX_RUNTIME__ = jsxRuntime;
}
